<template>
  <b-modal
    :title="file.categoria
      ? `Responder Expediente ${file.categoria}-${file.numero}`
      : `Responder Expediente ${file.numero}`"
    v-model="showModal"
    hide-footer
    centered
  >
    <form @keydown.enter.prevent autocomplete="off" data-vv-scope="answerForm">
      <div class="mt-3">
        <div class="bg-alert p-3">
          Por favor selecciona el archivo con el que quieres responder
          <strong>esto será visible por la persona que te ha enviado el expendiente para
            luego procesar la respuesta</strong>
        </div>
        <div class="row mt-6">
          <div class="col-12">
            <UploadFile
              permission="*"
              accept=".pdf, .png, .jpg, .jpeg, .xlsx, .docx, .xls, .doc"
              text="Seleccionar respuesta"
              data-cy="UploadFile"
              v-model="mainFile"
              :max-size-in-mb="30"
              upload-to="ed"
              :button-class="{ 'btn-block': true, 'mb-5': errors.has('step-3.mainFileName') }"
              container-class="w-100"
            />
          </div>
          <div class="col-12 mt-3 mb-4" v-if="Object.keys(mainFile).length">
            <div class="d-flex flex-column align-items-center">
              <vs-icon icon="description" size="75px" color="primary" />
              <strong class="text-truncate w-100 text-center">{{ mainFile.name }}</strong>
            </div>
          </div>
          <div class="col-md-12 mt-3">
            <UploadFile
              data-cy="upload-attachment"
              permission="*"
              text="Seleccionar adjuntos"
              accept=".pdf, .png, .jpg, .jpeg, .xlsx, .docx, .xls, .doc"
              v-model="additionalFile"
              upload-to="ed"
              :max-size-in-mb="30"
              button-class="btn-block"
              container-class="w-100"
              @input="addAdditionalFile()"
            />
          </div>
          <div class="col-3 mt-3 mb-3" v-for="file in additionalFiles" :key="file.id">
            <div class="d-flex flex-column align-items-center">
              <vs-icon icon="description" size="75px" color="primary" />
              <b class="text-truncate w-100 text-center">{{ file.name }}</b>
              <vs-button
                color="danger"
                type="flat"
                icon="clear"
                v-if="file.type !== 'respuesta'"
                @click="removeAdditionalFile(file.id)"
              />
              <b-badge
                data-cy="response"
                v-if="file.type === 'respuesta'"
                variant="light-info"
                class="mr-2"
              >
                respuesta
              </b-badge>
            </div>
          </div>
        </div>
      </div>
      <div class="m-top-20">
        <div
          class="text-danger text-caption d-block text-center"
          v-if="warningMessage && !this.mainFile.name"
        >
          Archivo de respuesta requerido
        </div>
        <div class="text-right mt-3">
          <vs-button
          data-cy="Cancel"
          color="dark"
          v-on:click="cancelAsign()"
          type="border">

          Cancelar
          </vs-button>
          <vs-button
            data-cy="send-reply"
            v-on:click="returnFile()"
            color="primary"
            style="margin-left: 12px;"
            type="border"
          >
            Enviar respuesta
          </vs-button>
        </div>
      </div>
    </form>
  </b-modal>
</template>
<script>

import { mapActions, mapGetters } from 'vuex';

import UploadFile from '@/febos/global/_vue/componentes/UploadFile';

export default {
  name: 'PopUpAnswerFileAguasAndinas',
  mixins: [],
  components: {
    UploadFile
  },
  data() {
    return {
      fileType: 'numInt',
      creatorGroup: '',
      additionalFile: {
        name: ''
      },
      mainFile: {},
      additionalFiles: [],
      warningMessage: false
    };
  },
  props: {
    file: {
      type: [Object],
      required: true,
      default: () => {}
    }
  },
  computed: {
    ...mapGetters('Modals', ['modalName']),
    ...mapGetters('List', ['userGroupsState']),
    ...mapGetters('Usuario', ['currentUser']),
    ...mapGetters('Empresas', ['company']),
    ...mapGetters('Dnts', ['detailsFile']),
    showModal: {
      get() {
        return this.modalName === 'answerFileAguasAndinas';
      },
      set() {
        this.closeModal();
      }
    },
    isArchivo() {
      if (this.additionalFile.name.length > 0) {
        return true;
      }
      return false;
    }
  },
  watch: {
    showModal(val) {
      this.additionalFile = {};
      this.mainFile = {};
      this.additionalFiles = [];
      this.warningMessage = false;
      if (val) this.getFileData();
    }
  },
  methods: {
    ...mapActions('Dnts', [
      'answerCreateFile',
      'getFileDnt',
      'returnFileEdAguasAndinas'
    ]),
    ...mapActions('Modals', [
      'closeModal'
    ]),
    async addAdditionalFile() {
      if (!Object.keys(this.additionalFile).length) {
        return;
      }

      if (this.additionalFile.failed) {
        this.error.message = 'La carga del archivo falló, inténtalo de nuevo';
        return;
      }

      this.additionalFiles.push(this.additionalFile);
      await this.$validator.reset();
    },
    removeAdditionalFile(fileId) {
      this.additionalFiles = this.additionalFiles.filter((file) => file.id !== fileId);
    },
    getFileData() {
      this.getFileDnt({
        febosId: this.file.febosId,
        dnt: 'si',
        retornarDnt: 'si',
        destinatarios: 'si',
        referencias: 'si',
        adjuntos: 'si',
        metadata: 'si'
      });
    },
    cancelAsign() {
      this.closeModal();
      this.additionalFile = {};
      this.mainFile = {};
      this.additionalFiles = [];
      this.warningMessage = false;
    },
    async returnFile() {
      let documents = [];
      if (this.mainFile.name) {
        documents = [
          {
            tipo: 'respuesta',
            adjuntoMime: this.mainFile.mime,
            adjuntoNombre: this.mainFile.name,
            fecha: this.mainFile.date,
            adjuntoUrl: this.mainFile.path
          }
        ];
      }

      if (this.additionalFiles.length) {
        documents = [
          ...documents,
          ...this.additionalFiles.map((file) => ({
            tipo: 'adjunto',
            adjuntoMime: file.mime,
            adjuntoNombre: file.name,
            fecha: file.date,
            adjuntoUrl: file.path
          }))
        ];
      }

      const haveResponse = documents.some((document) => document.tipo === 'respuesta');
      if (!haveResponse) {
        this.warningMessage = true;
      }

      if (documents.length && haveResponse) {
        const toReturn = {
          febosId: this.file.febosId,
          archivos: documents
        };
        await this.returnFileEdAguasAndinas(toReturn);
        this.warningMessage = false;
      } else {
        this.warningMessage = true;
      }
    }

  }
};
</script>
<style scoped>

.bg-alert {
  background: #a46cbd;
  border-radius: 5px;
  color: white;
}

</style>
